import { DecimalQuestionProps } from '../../types';
import { NumberInput } from '../components/number-input';
import { Controller, useFormContext } from 'react-hook-form';
import { NumberInputUnits } from '../components/number-input-units';

export const DecimalQuestion = ({ question }: DecimalQuestionProps) => {
  const { control, clearErrors } = useFormContext();

  const min = question.validations?.min as number;
  const max = question.validations?.max as number;

  return (
    <Controller
      control={control}
      name={question.slug}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const stringValue = value != null ? value.toString() : '';

        const handleChange = (stringValue: string) => {
          if (stringValue.trim() === '') {
            onChange('');
            return;
          }

          const numValue = parseFloat(stringValue);
          if (!isNaN(numValue)) {
            onChange(numValue);
          }
          // Clear any existing error for this field when user types
          clearErrors(question.slug);
        };
        const units = question.units !== undefined && typeof question.units === 'string' ? question.units : null;

        if (units) {
          return (
            <NumberInputUnits
              value={stringValue}
              onChange={handleChange}
              placeholder={question.placeholder?.toString()}
              error={error?.message}
              required={question.required}
              min={min}
              max={max}
              units={units}
            />
          );
        } else {
          return (
            <NumberInput
              value={stringValue}
              onChange={handleChange}
              placeholder={question.placeholder?.toString()}
              error={error?.message}
              required={question.required}
              min={min}
              max={max}
            />
          );
        }
      }}
    />
  );
};
